// Module
var code = "<br>Orders: :numberOrders <br>CreatedAt: :createdAtMin to :createdAtMax <br>SettledAt: :settledAtMin to :settledAtMax <br>With Order Data: :ordersWithDetails <br>With No Order Data: :ordersWithoutDetails <div class=\"button is-small\" id=\"viewOrdersSettlementsData\">View data</div> ";
// Exports
export default code;